module.exports = __webpack_public_path__ + "static/prof-barrios-9174bbe7e9de7c7271d81323e3a1b355.png";